import PrintLayout from './PrintLayout.enum';

export default Object.freeze({
	NetStamps: [
		PrintLayout.RollTypeSorD,
		PrintLayout.RollTypeSorDExt,
		PrintLayout.Traditional,
		PrintLayout.Standard,
		PrintLayout.Promotional,
		PrintLayout.Themed,
		PrintLayout.PhotoLandscape,
		PrintLayout.PhotoPortrait,
		PrintLayout.Alternate,
		PrintLayout.PhotoLandscapeHS,
		PrintLayout.PromoPaper20Netstamps,
		PrintLayout.ReturnAddress,
	],
	Envelope: [
		PrintLayout.EnvelopeInvitation,
		PrintLayout.EnvelopeGreeting,
		PrintLayout.EnvelopePersonal,
		PrintLayout.EnvelopeMonarch,
		PrintLayout.Envelope9,
		PrintLayout.Envelope10,
		PrintLayout.Envelope11,
		PrintLayout.Envelope12,
	],
	Label: [
		PrintLayout.Normal4x6,
		PrintLayout.Normal4x6CN22,
		PrintLayout.Normal4X6CP72,
		PrintLayout.NormalLeft,
		PrintLayout.NormalRight,
		PrintLayout.GPPlus,
		PrintLayout.GPPlusIntl,
		PrintLayout.NormalUps,
		PrintLayout.NormalDhl,
		PrintLayout.NormalFedex,
		PrintLayout.NormalCN22,
		PrintLayout.NormalCP72,
		PrintLayout.NormalReturn,
		PrintLayout.NormalReceipt,
	],
	CertifiedMail: [
		PrintLayout.Sdc3610,
		PrintLayout.Sdc3710,
		PrintLayout.Sdc3910,
		PrintLayout.Sdc3930,
		PrintLayout.Sdc3810,
		PrintLayout.Sdc3830,
	],
});
